import React from 'react';
import PropTypes from 'prop-types';
import {
  sortBy,
  find,
  filter,
} from 'lodash';
import {
  withStyles,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Avatar,
  ListItemSecondaryAction,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import { getIconForEventData } from '../../../utils/eventDataHelper';
import FieldDisplayMessage from '../../widgets/FieldDisplayMessage';

import styles from './styles';

const isSelectAllIndeterminate = (eventData, selectedItem) => eventData.length > selectedItem.length && selectedItem.length !== 0;

const EventDataSelectorComponent = (props) => {
  const {
    classes,
    availableItems,
    eventData,
    helperText,
    isAdmin,
    onChange,
    selectedItem,
  } = props;

  if (!availableItems && availableItems.length === 0) {
    return (
      <FieldDisplayMessage
        title="No Custom Fields defined for your organization"
        subTitle={
          isAdmin
            ? <Link to="/settings/events?tab=1" href="/settings/events?tab=1">Create custom fields now</Link>
            : 'Ask your organization administrator to create custom fields from the Event Settings page'
        }
        icon="info_outlined"
        disableGutters
      />
    );
  }

  const handleEventDataClick = (eventDataItem) => {
    if (find(selectedItem, eventDataItem)) {
      return onChange(filter(selectedItem, (item) => item.id !== eventDataItem.id));
    }
    return onChange([
      ...selectedItem,
      eventDataItem,
    ]);
  };

  const handleSelectAllClick = () => {
    if (isSelectAllIndeterminate(eventData, selectedItem) || selectedItem.length === 0) {
      onChange(eventData);
    } else {
      onChange([]);
    }
  };

  return (
    <div>
      <div className={classes.header}>
        <Typography variant="caption" className={classes.labelContainer}>
          Custom Fields
          {
            helperText
              && (
                <Tooltip title={helperText}>
                  <Icon className={classes.infoIcon} color="disabled">info_outline</Icon>
                </Tooltip>
              )
          }
        </Typography>
        <Typography variant="caption">
          Select All
          <Checkbox
            checked={eventData.length === selectedItem.length && eventData.length !== 0}
            indeterminate={isSelectAllIndeterminate(eventData, selectedItem)}
            onClick={handleSelectAllClick}
            disabled={eventData.length === 0}
          />
        </Typography>
      </div>
      <List classes={{ root: classes.listRoot }}>
        {
          sortBy(eventData, ['order', 'name'])
            .map((eventDataItem) => (
              <ListItem
                button
                dense
                onClick={() => handleEventDataClick(eventDataItem)}
                key={`event-data-selector-${eventDataItem.name.replaceAll(/\s/g, '_')}`}
              >
                <ListItemIcon>
                  <Avatar>{getIconForEventData(eventDataItem)}</Avatar>
                </ListItemIcon>
                <ListItemText>
                  {eventDataItem.name}
                </ListItemText>
                <ListItemSecondaryAction>
                  <Checkbox checked={!!find(selectedItem, eventDataItem)} onClick={() => handleEventDataClick(eventDataItem)} />
                </ListItemSecondaryAction>
              </ListItem>
            ))
        }
      </List>
    </div>
  );
};

EventDataSelectorComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  availableItems: PropTypes.array.isRequired,
  eventData: PropTypes.array.isRequired,
  helperText: PropTypes.string,
  isAdmin: PropTypes.bool,
  onChange: PropTypes.func,
  selectedItem: PropTypes.array,
};

EventDataSelectorComponent.defaultProps = {
  helperText: null,
  isAdmin: false,
  onChange: () => {},
  selectedItem: [],
};

export default withStyles(styles)(EventDataSelectorComponent);
